export const ALREADY_CONFIRM_RESPONSE_STATUS_CODE = 406

export const PHONE_SIZE = 11
